import { render, staticRenderFns } from "./AddPartyForm.vue?vue&type=template&id=6b8a246a&scoped=true"
import script from "./AddPartyForm.vue?vue&type=script&lang=ts"
export * from "./AddPartyForm.vue?vue&type=script&lang=ts"
import style0 from "./AddPartyForm.vue?vue&type=style&index=0&id=6b8a246a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a246a",
  null
  
)

export default component.exports